
/* */
export const getPrimaryColor = state => state.core.primaryColor;

/* */
export const getSecondaryColor = state => state.core.secondaryColor;

/* */
export const getTheme = state => state.core.theme;

/* */
export const getUser = state => state.core.user;

/* */
export const getSessionKey = state => state.core.sessionKey;

/* */
export const getSnackMessageQueue = state => state.core.snackMessageQueue;

/* */
export const getSnackMessageItem = state => state.core.snackMessageItem;

/* */
export const getLoginState = state => state.core.loginState;

/* */
export const getAvailableScreens = state => state.core.availableScreens;

/* */
export const getShowSplash = state => state.core.showSplash;

/* */
export const getCheckSaveIdentity = state => state.core.checkSaveIdentity;

/* */
export const getPasswordChangeKey = state => state.core.passwordChangeKey;

/* */
export const getPasswordChangeKeyExpiration = state => state.core.passwordChangeKeyExpiration;

/* */
export const getManualPasswordChange = state => state.core.manualPasswordChange;

/* */
export const getPushEndpoint = state => state.core.pushEndpoint;

/* */
export const getPushKey = state => state.core.pushKey;

/* */
export const getPushAuth = state => state.core.pushAuth;

/* */
export const getUpdatingUser = state => state.core.updatingUser;

/* */
export const getUpdateUserAgain = state => state.core.updateUserAgain;

/* */
export const getBusyOpen = state => state.core.busyOpen;

/* */
export const getBusyMessage = state => state.core.busyMessage;

/* */
export const getApiInfo = state => state.core.apiInfo;

/* */
export const getAgentUserSession = state => state.core.agentUserSession;
